import { AutocompleteOption } from '@cp/ds/src/components/form';
import { CityViewModel } from '@common/model/location/cityViewModel';

export interface ICityOption extends AutocompleteOption {
  id: number;
  region?: string;
  model: CityViewModel;
}

export const cityModelToOption = (m: CityViewModel): ICityOption => ({
  id: m.id,
  value: m.id,
  label: m.translation.name,
  region: m.translation.regionName,
  model: m,
});
